import * as React from 'react';

import s from './LinkList.module.scss';
import { LinkListItem } from '../../types';

export interface LinkListProps {
    links?: Array<LinkListItem>;
    title?: string;
}

const LinkList: React.FC<LinkListProps> = (props) => {
    const {
        links,
        title,
    } = props;

    return (
            <div className={s.Root}>
                {title && (
                    <h3 className={s.Title}>{title}</h3>
                )}
                {links && (
                    <ul className={s.List}>
                        {links.map((linkItem, index) => (
                            <li key={index} className={s.ListItem}>
                                <a
                                    className={s.Link}
                                    href={linkItem.link.href}
                                >
                                    {linkItem.link.text}
                                    <span className={s.Description}>{linkItem.description}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
    );
};

export default LinkList;
